'use client';

import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import Text from '~/components/customComponents/texts/Text';
import { AndercoreExternalLinks } from '~/constants/endpoints';
import { useI18n, useCurrentLocale } from '~/locales/client';
import { LocaleEnum } from '~/locales/resources';

type TermsAndConditionsAgreementProps = {
  className?: string;
};

/**
 * TermsAndConditionsAgreement component for registration forms
 * Displays terms agreement text with clickable links for:
 * - General Terms and Conditions / AGB
 * - Data Processing Agreement / AVV
 * - Privacy Policy / Datenschutzerklärung
 */
const TermsAndConditionsAgreement = ({ className }: TermsAndConditionsAgreementProps) => {
  const translate = useI18n();
  const locale = useCurrentLocale();
  const externalLinks = AndercoreExternalLinks[locale as LocaleEnum] || AndercoreExternalLinks.en;

  const termsAndConditionsText = translate('general.terms-agreement', {
    generalTermsAndConditions: (
      <Link
        href={externalLinks.terms}
        className="underline underline-offset-2 hover:text-gray-900"
        prefetch={false}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {translate('general.general-terms-and-conditions')}
      </Link>
    ),
    privacyPolicy: (
      <Link
        href={externalLinks.privacy}
        className="underline underline-offset-2 hover:text-gray-900"
        prefetch={false}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {translate('general.privacy-policy')}
      </Link>
    ),
  });

  return (
    <Text className={twMerge('text-sm text-gray-700', className)}>{termsAndConditionsText}</Text>
  );
};

export default TermsAndConditionsAgreement;
